const resources = {
  'Menu.MakeItRight': 'Make it right',
  'Menu.MakeItMagic': 'Make it magic',
  'Menu.MakeItWork': 'Make it work',
  'Menu.Brief': 'Brief',
  'Menu.Brief.Description': 'Elevate your work and ensure project alignment from the get-go.',
  'Menu.Growth': 'Path to Growth',
  'Menu.Growth.Description':
    'Set your business growth goals, understand how media can contribute, and progress into the right path to achieve them.',
  'Menu.Audience': 'Audience',
  'Menu.Audience.Description':
    'Discover, research, and get under the skin of your most valuable audiences.',
  'Menu.Inspire': 'Inspire',
  'Menu.Inspire.Description':
    'Find the insights and that game-changing idea that will make your campaign buzz.',
  'Menu.Design': 'Design',
  'Menu.Design.Description':
    'Build a best-in-class media plan for your audiences and ideas, to ultimately achieve your growth goals.',
  'Menu.Activate': 'Activate',
  'Menu.Activate.Description':
    'Deploy your plan and develop your campaign with the right activation techniques.',
  'Menu.Reporting': 'Optimize and Report',
  'Menu.Reporting.Description':
    'Analyze your paid, owned, and earned campaign reporting & insights to make smart business decisions and discover impactful trends.',
  'UserIcons.Dashboard': 'Dashboard',
  'UserIcons.EditProfile': 'Edit Profile',
  'UserIcons.LogOut': 'Log Out',
  'Menu.Planning': 'Planning',
  'Menu.Activation': 'Activation',
  'Menu.Investment': 'Investment Tracker',
  'Footer.Description':
    'The Publicis Growth OS is an end-to-end way of working that seamlessly connects all data, technology, and people from across the marketing landscape. Using the OS, users uncover  untapped growth potential by generating a deeper understanding of their business and the needs of their consumers.',
  'Footer.Links':
    'Privacy Policy &nbsp;&nbsp; | &nbsp;&nbsp; Terms & Conditions &nbsp;&nbsp; | &nbsp;&nbsp; Disclaimer',
  'Menu.NoAccessToModule': 'This Module is currently not available for you.',
  'WelcomeModal.SubTitle': 'What would you like to do today?',
  'WelcomeModal.SectionA.Title': 'Start Brief',
  'WelcomeModal.SectionA.SubTitle': 'Looking to start a new project?',
  'WelcomeModal.SectionA.Description': 'Go directly to Brief.',
  'WelcomeModal.SectionA.LinkText': 'New Brief',
  'WelcomeModal.SectionB.Title': 'Track Performance',
  'WelcomeModal.SectionB.SubTitle': '',
  'WelcomeModal.SectionB.Description': 'See how your brand is performing.',
  'WelcomeModal.SectionB.LinkText': 'Home',
  'WelcomeModal.SectionC.Title': 'Get Help',
  'WelcomeModal.SectionC.SubTitle': 'Have a question?',
  'WelcomeModal.SectionC.Description': 'Contact one of our experts.',
  'WelcomeModal.SectionC.LinkText': 'Help',
  'BugReportModal.Title': 'Need help?',
  'BugReportModal.SubTitle': 'Please send us a bug report by filling in our email form.',
  'BugReportModal.Description':
    'Share with us any questions or issues you have encountered and we’ll help you figure them out.',
  'BugReportModal.LinkText': 'CONTACT US',
  'BugReportMail.Email': 'GrowthOS@Publicisgroupe.com',
  'BugReportMail.Subject': 'Inquiry - Please specify',
  'BugReportMail.Body': `Please share a screenshot, including your selected OS filters.


Dear Growth OS Team,

I have the following question:`,
  'WelcomeModal.UserChoiceText': "Don't show me this screen again",
  'Loader.Text': 'Please wait, while we are Loading...',
  'Footer.ReservedRightsNote': 'Publicis Groupe, all rights reserved',
  'Footer.PoweredbyText': 'Powered by',
  'Dashboard.Welcome': 'Welcome,',
  'Dashboard.Title': 'Personalize your OS Experience',
  'Dashboard.LoggedIn': 'You are logged in as:',
  'Dashboard.UserChoiceText': "Don't show me this screen again",
  'DashboardMobile.SubTitle': 'Please create your Dashboard view',
  'DashboardMobile.Done': 'Done',
  'Login.PublicisPanel.Title': `PUBLICIS`,
  'Login.PartnerPanel.Title': `PARTNER`,
  'Login.PublicisPanel.Description': `Publicis Groupe uses network username and password to login.`,
  'Login.PartnerPanel.Description': `Publicis Partner uses network username and password to login.`,
  'Login.LogoDescription': `Welcome to Publicis Growth OS: A connected marketing services technology designed to enable our people to unlock exponential growth for brands.`,
  'Login.Header': `Log in as`,
  'Login.Header.Mobile': `Log in`,
  'Login.Button': `LOG IN`,
  'Login.RequestAccess': `Dont have an account with us?`,
  'Login.BottomContent': `Request Access`,
  NoAccess: 'You have no access rights for this page',
  'NoAccess.Title': 'Authorizations to view OS Modules missing.',
  'NoAccess.Text': 'Please contact an OS administrator to configure your OS Module Access.',

  'HelpSection.PageInfo.Title': 'PAGE INFO',
  'HelpSection.PageInfo.Header':
    'We have customised the page breakup for you. Click On the page to know more about each sections of the module.',
  'HelpSection.PageInfo.ProTips': 'Pro Tips:',
  'HelpSection.PageInfo.ContactTeam': 'CONTACT TEAM',
  'HelpSection.PageInfo.ScheduleMeeting': 'Schedule A Meeting',
  HelpSectionNoData:
    'Oops! Sorry, currently this module information is not available or under construction. For further details, <b>please reach out to your administrator</b>.',
  'HelpSection.FAQ.Title': 'FAQs',
  'HelpSection.FAQ.Header': 'Here are some common questions regarding the Module.',
  'HelpSection.FQA.Footer':
    'We have created a list of FAQ’s which should help you in understanding PGOS better. If You are not able to find your question, check our comprehensive FAQs page.',
  'HelpSection.FQA.Footer.ButtonText': 'Contact Team',
  'HelpSection.Glossary.Title': 'Glossary',
  'HelpSection.Glossary.Header': 'Here are some common glossary terms regarding the Module.',

  'UserProfile.CookieSettings': 'Cookie Settings',
  UserProfileSwitchToConfigView: 'Switch to Config View',
  'CookieBanner.Accept': 'Accept',
  'CookieBanner.Decline': 'Decline',
  'CookieBanner.More': 'More',
  'CookieBanner.Back': 'Back',

  'NotificationSection.Title': 'News Feed',
  'NotificationSection.Today': 'Today',
  'NotificationSection.LastSevenDays': 'Last seven days',
  'NotificationSection.AllTime': 'All time',
  'NotificationSection.NoData': 'You have no notification right now. Come back later.',

  'DaimlerLoginScreen.BackgroundImage':
    'https://www.suvdrive.com/sites/default/files/public/45%20angle%20view/45%20angle%20front%20Mercedes-Benz%20CLA-Class%204MATIC%20CLA250%202020_0.jpg',
  'DaimlerLoginScreen.Logo':
    'https://www.pngkit.com/png/full/136-1362714_mercedes-benz-logo-mercedes-white-logo-png.png',

  'ColaLoginScreen.BackgroundImage':
    'https://i.pinimg.com/originals/98/c7/6b/98c76b1198f8b47dbefd349ca607ab0f.gif',
  'ColaLoginScreen.Logo':
    'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/The_Coca-Cola_Company_logo.svg/1280px-The_Coca-Cola_Company_logo.svg.png',

  'StarWarsLoginScreen.BackgroundImage':
    'https://cdn.wallpaperhub.app/cloudcache/1/8/7/0/a/8/1870a826a6d27744f338d86e62756ed74721a629.jpg',
  'StarWarsLoginScreen.Logo':
    'https://logodownload.org/wp-content/uploads/2015/12/star-wars-logo-3-1.png',
  CookieLoadErrorTitle: 'Cookies Failure',
  CookieLoadErrorMessage:
    'System encounters cookies load issue. Might affect your browsing experience. Retry or contact admin for support.',
  HelpSectionErrorTitle: 'Help Section Error',
  PageInfoErrorMessage:
    'Unable to retrieve Page Info data in Help Section. Please refresh or contact admin for support.',
  FaqErrorMessage:
    'Unable to retrieve FAQ data in Help Section. Please refresh or contact admin for support.',
  GlossaryErrorMessage:
    'Unable to retrieve Glossary data in Help Section. Please refresh or contact admin for support.',
};

export const t = (key: string, html?: boolean) => {
  if (html && key in resources) {
    return <span dangerouslySetInnerHTML={{ __html: (resources as any)[key] }} />;
  }

  return key in resources ? (resources as any)[key] : key;
};
